import React from "react";
import { findNodeById } from "../NodeUtils";
import { useNodeActions } from "../hook/useNodeActions";
import { useSelection } from "./SelectionContext";
import { useHover } from "./HoverContext";
import { useDragContext } from "./DragContext";

export function NodeActions({ nodeId, page, setPage }) {

  const {
    addContainerAction,
    addCardAction,
    addElementAction,
    removeNodeAction,
    duplicateNodeAction,
    moveNodeAction
  } = useNodeActions(page, setPage);
const { selectedNodeId } = useSelection();
  const { hoverNodeId } = useHover();

const { draggingNodeIdRef } = useDragContext();
  const isActive = selectedNodeId === nodeId || hoverNodeId === nodeId;

  if (!isActive) return null; // Only show on hover or selection

  const result = findNodeById(page, nodeId);
  if (!result) return null;

  const { level, path } = result;

  const sectionId = page.sections[path.sectionIndex]?.id;
  const containerId =
    page.sections[path.sectionIndex]?.contents[path.containerIndex]?.id;
  const cardId =
    page.sections[path.sectionIndex]?.contents[path.containerIndex]?.cards[path.cardIndex]?.id;

  return (
   <div
   
  //  draggable
  //   onDragStart={(e) => {
  //     e.stopPropagation();
  //     e.dataTransfer.setData("nodeId", nodeId);
  //     draggingNodeIdRef.current = nodeId;
  // }}
  // onDragEnd={() => {
  //   draggingNodeIdRef.current = null;
  // }}
      style={{
        display: "flex",
        gap: "4px",
        position: "absolute",
        top: "-16px",
        right: 0,
        background: "#fff",
        borderRadius: 4,
        padding: "4px 8px",border:"2px dashed rgba(26, 115, 232, 0.51) ",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        zIndex: 990
      }}
    >
      {/* DRAG HANDLE */}
  <button
    className="drag-btn"
   
  >
    ⠿
  </button>
      {/* Move Buttons */}
      <button onClick={() => moveNodeAction(nodeId, "up")}>↑</button>
      <button onClick={() => moveNodeAction(nodeId, "down")}>↓</button>

      {/* Add */}
      {level === "section" && (
        <button onClick={() => addContainerAction(nodeId)}>+C</button>
      )}
      {level === "container" && (
        <button onClick={() => addCardAction(sectionId, nodeId)}>+Card</button>
      )}
      {level === "card" && (
        <button onClick={() =>
          addElementAction(sectionId, containerId, nodeId, {
            type: "header",
            content: "New Element",
            styles: { default: {}, theme: {}, custom: {} }
          })
        }>+El</button>
      )}

      {/* Duplicate */}
      {level !== "section" && (
        <button onClick={() => duplicateNodeAction(nodeId)}>⧉</button>
      )}

      {/* Delete */}
      {level !== "section" && (
        <button onClick={() => removeNodeAction(nodeId)}>🗑</button>
      )}
    </div>
  );
}
